import React, { useRef, useEffect } from "react";

import { THEMES } from "../../../../constants";

import "./themes.css";
import changeTheme from "../../../../utils/changeTheme";

const Themes = ({ personalisedExperience, setPersonalisedExperience }) => {
  const graph = useRef(null);

  useEffect(() => {
    const ciclegraph = graph.current;
    const circleElements = ciclegraph.childNodes;

    let angle = 360 - 90;
    let dangle = 360 / circleElements.length;

    for (let i = 0; i < circleElements.length; i++) {
      let circle = circleElements[i];
      angle += dangle;
      circle.style.transform = `rotate(${angle}deg) translate(${
        ciclegraph.clientWidth / 2
      }px) rotate(-${angle}deg)`;
    }
  }, []);

  let handleClick = theme => {
    changeTheme(theme);
    setPersonalisedExperience({
      selectedThemeId: theme.id,
      theme_name: theme.name,
    });
  };
  return (
    <div className="ml-5">
      <div
        className="ciclegraph"
        ref={graph}
        style={{
          padding: 100,
        }}
      >
        {THEMES.map(theme => (
          <div
            className={
              personalisedExperience.selectedThemeId === theme.id
                ? "circle selectedColor"
                : "circle"
            }
            style={{
              background: theme["--pallet-color"],
            }}
            onClick={() => handleClick(theme)}
          />
        ))}
      </div>
    </div>
  );
};

export default Themes;
